"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobileStylesHelper_1 = require("../assets/mobileStylesHelper");

var mobile = {
  '&$h3': {
    lineHeight: '20px'
  },
  '&$extra_small': {
    fontSize: '11px'
  }
};

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      fontH0 = _a.fontH0,
      fontH1 = _a.fontH1,
      fontH2 = _a.fontH2,
      fontH3 = _a.fontH3,
      fontH4 = _a.fontH4,
      fontBody = _a.fontBody,
      fontFootnote = _a.fontFootnote,
      fontSize1 = _a.fontSize1,
      fontControl = _a.fontControl,
      fontControlLabel = _a.fontControlLabel,
      colorPrimary = _a.colorPrimary,
      colorLink = _a.colorLink,
      colorLinkVisited = _a.colorLinkVisited,
      colorTextSecondary = _a.colorTextSecondary,
      colorText = _a.colorText,
      colorSuccess = _a.colorSuccess,
      colorError = _a.colorError,
      colorNotify = _a.colorNotify,
      colorTextContrast = _a.colorTextContrast;
  return __assign({
    base: __assign(__assign({
      fontFamily: fontFamily
    }, fontBody), {
      display: 'inline',
      margin: 0,
      color: colorText.normal
    }),
    h0: __assign(__assign({}, fontH0), {
      fontWeight: 'normal',
      marginBottom: 0,
      display: 'block'
    }),
    h1: __assign(__assign({}, fontH1), {
      marginBottom: 0,
      display: 'block'
    }),
    h2: __assign(__assign({}, fontH2), {
      marginBottom: 0,
      display: 'block'
    }),
    h3: __assign(__assign({}, fontH3), {
      marginBottom: 0,
      display: 'block'
    }),
    h4: __assign(__assign({}, fontH4), {
      marginBottom: 0,
      display: 'block'
    }),
    control: __assign({}, fontControl),
    small: __assign({}, fontFootnote),
    extra_small: __assign({}, fontSize1),
    label: __assign({}, fontControlLabel),
    success: {
      color: colorSuccess.normal
    },
    primary: {
      color: colorPrimary.normal
    },
    secondary: {
      color: colorTextSecondary.normal
    },
    error: {
      color: colorError.normal
    },
    notify: {
      color: colorNotify.normal
    },
    contrast: {
      color: colorTextContrast.normal
    },
    inline: {
      display: 'inline'
    },
    block: {
      display: 'block'
    },
    bold: {
      fontWeight: 'bold'
    },
    nowrap: {
      whiteSpace: 'nowrap'
    }
  }, mobileStylesHelper_1.default(mobile));
};